import React from "react";

import { FaNewspaper } from "react-icons/fa";

import * as NotificationUtils from "../../../lib/util/NotificationUtils";
import { useNotificationVisible } from "../../../lib/hook/NavigationHooks";

interface NotificationBannerProps {
	notification: NotificationUtils.PortalNotification;
}

const NotificationBanner: React.FC<NotificationBannerProps> = (props) => {
	const visible = useNotificationVisible(
		NotificationUtils.NOTIFICATION_TYPE_BANNER,
		props.notification.level,
	);

	return visible ? (
		<div className={"NotificationBanner --pdf-ignore"}>
			<div className={"NotificationBanner__content"}>
				<FaNewspaper className={"NotificationBanner__icon"} />
				<p
					dangerouslySetInnerHTML={{
						__html: NotificationUtils.cleanNotificationMessage(
							props.notification.message,
						),
					}}
				/>
			</div>
		</div>
	) : null;
};

export default NotificationBanner;
